// extracted by mini-css-extract-plugin
export default {"back_arrow_container":"BackArrow_back_arrow_container__O8ncv"};